/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Psod_PersistentInputs */

const fr_psod_persistent = /** @type {(inputs: Psod_PersistentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si le problème persiste, vous pouvez également essayer de réinitialiser les données de l'application.`)
};

const en_psod_persistent = /** @type {(inputs: Psod_PersistentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If the problem persists, you can also try resetting the application data.`)
};

/**
* | output |
* | --- |
* | "If the problem persists, you can also try resetting the application data." |
*
* @param {Psod_PersistentInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const psod_persistent = /** @type {((inputs?: Psod_PersistentInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Psod_PersistentInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_psod_persistent(inputs)
	return en_psod_persistent(inputs)
});